'use strict';
var ACC;
ACC.contactus = {
    map: '',

    // (called on document ready) append error icons on invalid fields
    appendErrorIcons: function () {
        var form = document.querySelector('#tjxContactUsForm'),
            fields = 
                form.querySelectorAll('input[type=text], input[type=tel], input[type=email], select, textarea'),
            VA = ACC.validation;
        
        // polyfill for IE11 coverage of '.matches()' method
        if (!Element.prototype.matches)
            Element.prototype.matches = Element.prototype.msMatchesSelector || 
                Element.prototype.webkitMatchesSelector;

        // polyfill for IE11 coverage of '.closest()' method
        if (!Element.prototype.closest) {
            Element.prototype.closest = function(s) {
                var el = this;
                if (!document.documentElement.contains(el)) return null;
                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1); 
                return null;
            };
        }

        // IE11 appropriate 'long' forEach format
        Array.prototype.forEach.call( fields, function(field, i) {
            if (field.closest('.form-group.has-error') !== null) {
                if (field.tagName == 'TEXTAREA') {
                    ACC.contactus.validateTextArea(field);
                } else if (field.tagName =='SELECT') {
                    var selectedVal = ACC.contactus.getSelectFieldValue(field);

                    VA.inputFieldErrorViewHandler(field, selectedVal.length > 0);
                } else {
                    VA.inputFieldErrorViewHandler(field, VA.validateInput(field));
                }
            }
        });
    },

    // set textarea listener(s)
    setTextAreaListeners: function() {
        document.querySelector('#tjxContactUsForm textarea').addEventListener('blur', function() {            
            ACC.contactus.validateTextArea(this);
        }, false);
    },

    // helper method - textarea validation handler
    validateTextArea: function(el) {
        var errorMsg = el.dataset.errorRegex.length ? el.dataset.errorRegex : '';

        ACC.validation.inputFieldErrorViewHandler(el, el.value.length > 0, errorMsg);
    },

    // helper method - checks and returns select field values
    getSelectFieldValue: function(el) {
        var val = el.selectedOptions && el.selectedOptions[0] && el.selectedOptions[0].value.length ?
            el.selectedOptions[0].value :
            '';

        return val;
    },

    // set select listener(s)
    setSelectValidationListeners: function() {
        var select = document.querySelector('#tjxContactUsForm select'),
            allSelectFields = document.querySelectorAll('#tjxContactUsForm select'),
            VA = ACC.validation;

        Array.prototype.forEach.call( allSelectFields, function(field, i) {
                if (field.value !== null) {
                    field.classList.remove('inactive');
                }
            });
        // Helper for showing/hiding the legal message
        function updateLegalMessage(val) {
            const $msgInput = $(`.option-message[data-value="${val}"]`);
            if ($msgInput.length) {
                const message = $msgInput.val();
                $('.contact-us-legal-message').text(message).addClass('show-container').show();
            } else {
                $('.contact-us-legal-message').removeClass('show-container').hide();
            }
        }

        // standard (non-selectric) select field validation
        select
            .addEventListener('blur', function() {   
                var selectedVal = ACC.contactus.getSelectFieldValue(this);

                if (selectedVal.length) {
                    this.classList.remove('inactive');
                }

                VA.inputFieldErrorViewHandler(this, selectedVal.length > 0);
            }, false);

        $(select)
            .on('selectric-init', function(event, selectEl, selectric) {
                var $button = selectric.elements.wrapper;
                $button.on('blur', function() {
                    var selectedVal = ACC.contactus.getSelectFieldValue(selectEl);
                    VA.inputFieldErrorViewHandler(selectEl, selectedVal.length > 0);
                });
            });
        // 'selectric' field validation - NOTE: must use jQuery as selectric is a jQuery based, Native JS can not intercept such events
        $(select)
            .on('selectric-close selectric-change', function() {
                const val = $(this).val();
                updateLegalMessage(val);
                const $selectedOption =
                    $(this).closest('.form-group')
                    .find('li.selected:not(.disabled)');

                VA.inputFieldErrorViewHandler($(this), $selectedOption.length > 0);
            });
        
        // Native select: change event (mobile/fallback)
        if (select) {
            select.addEventListener('change', function() {
                const val = this.value;
                updateLegalMessage(val);
            });
        }
    },
    onSubmit: function() {
        function validateSubmit(event) {
            event.preventDefault();

            // validate form empty 
            var elements = $("#tjxContactUsForm")
            .find("input[type=text], input[type=tel], input[type=email], select, textarea");

            for (const element of elements) {
                if (!element.value) {
                    $( '#'+element.id ).trigger( "blur" );
                }
            }
            // validate select form empty 
            var selectedVal = ACC.contactus.getSelectFieldValue(document.querySelector( '#contact-us-Service-Now-Option'));
            ACC.validation.inputFieldErrorViewHandler($( '#contact-us-Service-Now-Option' ), selectedVal.length > 0);
            
            // validate text area form empty 
            var el = document.querySelector('#contact-us-message');
            ACC.contactus.validateTextArea(el);
            
            // validate errors 
            var elementsWithErrorsList = form.getElementsByClassName("has-error");

            if (elementsWithErrorsList && elementsWithErrorsList[0]) {
                elementsWithErrorsList[0].scrollIntoView({
                    behavior: 'auto',
                    block: 'center',
                    inline: 'center' });

                var input = elementsWithErrorsList[0].getElementsByTagName('input')[0];
                var txtarea = elementsWithErrorsList[0].getElementsByTagName('textarea')[0];

                if(input) {
                    input.focus();
                } else if(txtarea) {
                    txtarea.focus();
                }

            } else {
                event.target.submit();
            }
        }

        const form = document.getElementById("tjxContactUsForm");
        
        form.addEventListener("submit", validateSubmit);
    }
};
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.page-contactUsFormPage')) {
        ACC.contactus.appendErrorIcons();
        ACC.contactus.setTextAreaListeners();
        ACC.contactus.setSelectValidationListeners();
        ACC.contactus.onSubmit();
    }
}, false);
